<template>
<ul class="radio-list">
  <li
    class="radio-label"
    v-for="(step, index) in steps"
    :key="index"
  >
    <input
      type="radio"
      :name="step.text"
      :value="step"
      v-model="selected"
      @change="handleSelect"
    >
    <label class="label">{{ step.text }}</label>
  </li>
</ul>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    roundIndex: Number,
    onSelect: {
      type: Function,
      default: () => () => {}
    }
  },

  data() {
    return {
      selected: null
    };
  },
  methods: {
    handleSelect() {
      this.onSelect('singleSelect', this.roundIndex, [this.selected]);
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-list {
  padding-left: 7%;
  flex: 1;

  li {
    font-weight: 400;
    list-style: none;
  }

  .title {
    margin-bottom: 30px;
    font-size: 22px;
  }

  .radio-label {
    margin: 20px;
    font-size: 30px;

    label {
      padding-left: 30px;
    }
  }
}

[type="radio"] {
  opacity: 0;
  min-height: 18px;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  left: -12px;
}
[type="radio"] + label {
  position: relative;
}
[type="radio"] + label:before {
  content: "";
  position: absolute;
  left: -28px;
  top: 14px;
  width: 13px;
  height: 13px;
  border: 1px solid #000;
  border-radius: 100%;
  pointer-events: none;
  cursor: pointer;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 7px;
  height: 7px;
  background: #000;
  position: absolute;
  top: 18px;
  left: -24px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
</style>
